import * as angular from "angular";
import * as _ from "lodash";
import {IQService} from "angular";

export class PreferencesRequestsService {

  private allPreferences: any;
  private preferencesRef: any;

  /* @ngInject */
  constructor(private $preferences, private $settings, private SettingsAPI, private $q: IQService) {
    this.allPreferences = {};
  }

  // ******************************
  // External methods
  // ******************************

  getPreferences() {
    return _.isEmpty(this.allPreferences) ? this.fetchPreferences() : this.$q.when(this.allPreferences);
  }

  getGeneralTasks(type) {
    const api = this.SettingsAPI.actions.getGeneralTasks;
    return this.$$call(api, {type: type}, {}, {});
  }

  updateGeneralTask(generalTask) {
    const api = this.SettingsAPI.actions.updateGeneralTask;
    return this.$$call(api, {}, generalTask, {});
  }

  // ******************************
  // Internal methods
  // ******************************

  fetchPreferences() {
    const deferred = this.$q.defer();

    const preferencesRef = this.$preferences();

    preferencesRef.$getAll()
      .then((preferencesIds) => {
        return preferencesRef.$asyncValues(preferencesIds);
      })
      .then((preferences) => {
          if (preferences) {
            _.forEach(preferences, (element) => {
              const parentGroupName = _.get(element, "parentGroupName");
              const parentGroup = _.get(element, "parentGroup");
              const groupName = _.get(element, 'groupName');
              const group = _.get(element, 'group');
              const key = _.get(element, 'key');

              var tab = _.camelCase(parentGroup);
              var card = _.camelCase(group);

              if (_.isUndefined(this.allPreferences[tab])) {
                _.set(this.allPreferences, tab, {})
              }

              if (_.isUndefined(this.allPreferences[tab][card])) {
                _.set(this.allPreferences[tab], card, {
                  name: groupName,
                  list: []
                })
              }

              this.allPreferences[tab][card].list.push(element);
            });

            deferred.resolve(this.allPreferences);

          }
        })
      .catch((error) => {
          deferred.reject(error);
      });
    return deferred.promise;
  }

  $$call(_apiCall, _params, _data, _options) {
    return this.$settings().$call(_apiCall, _params, _data, _options);
  }

}
angular
  .module('bringoz.admin.site-preferences')
  .service('preferencesRequestsService', PreferencesRequestsService);
